import { Info } from 'lucide-react'
import { Tooltip } from '@/components/Tooltip'

export interface InfoTooltipProps {
  text: string
}

// Same Lock+Tooltip pattern already used to explain a disabled control
// (OrchestrationStepsSection.tsx, FieldRow.tsx), applied to explaining a
// concept instead - a small icon next to a label, badge, or column header
// that a non-technical admin might not recognise.
export function InfoTooltip({ text }: InfoTooltipProps) {
  return (
    <Tooltip text={text}>
      <span tabIndex={0} className="text-text-secondary">
        <Info size={12} strokeWidth={1.5} />
      </span>
    </Tooltip>
  )
}
